import React, { useRef, useState, useContext, useEffect } from "react";
import dayjs from "dayjs";

import styled from "@emotion/styled";
import Dialog from '@mui/material/Dialog';
import Typography from "@mui/material/Typography";

import CustomButton from "../Common/CustomButton";

import { getTaskHistory } from "../../apis/taskManagement";

const Container = styled("div")(({ theme }) => ({
  width: "100%",
  "& .heading": {
    padding: "0.5rem",
    borderBottom: "1px solid #EAEAEA",
    "& .text_style": {
      fontWeight: "600",
      fontSize: "18px",
    },
  },
  "& .main": {
    // width: "100%",
    width: `cal(100% - 0.4rem)`,
    padding: "1rem 0.7rem",
    height: "350px",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      width: "0.4em",
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#e9e9e9",
      borderRadius: "30px",
    },
    "& .task": {
      display: "flex",
      border: "1px solid #EAEAEA",
      padding: "0.5rem",
      marginBottom: "1rem",
      justifyContent: "space-between",
      borderRadius: "4px",
      "& .info": {
        width: "70%",
        color: "#4F4F4F",
        fontSize: "14px",
        "& .name": {
          color: "#000",
          fontWeight: "500",
          fontSize: "14px",
        },
      },
      "& .date_container": {
        width: "30%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "1rem",
        "& .date_style": {
          color: "#4F4F4F",
          fontSize: "12px",
        },
        "& .date_style_1": {
          color: "#4F4F4F",
          fontSize: "12px",
        }
      }
    },
  },
  "& .bottom_container": {
    borderTop: "1px solid #EAEAEA",
    padding: "0.5rem",
    display: "flex",
    justifyContent: "flex-end",
    gap: "0.5rem",
    "& .btn_styl": {
      borderRadius: "10px",
    }
  }
}));

const TaskHistoryDialog = (props) => {
  const { onClose, selectedValue, open, taskId, statusList } = props;
  const [history, setHistory] = useState([]);
  const handleClose = () => {
    onClose(selectedValue);
  };

  const getTaskHistoryData = async (id) => {
    if (id) {
      const { data, error } = await getTaskHistory(id);
      if (error) {
        if (error.status === 401) {
          console.log("error");
        } else if (error.status === 404) {
          // alert("No users available for your state");
          return;
        } else {
          // alert("Couldn't fetch the data");
          return;
        }
      }
      if(data && data?.length > 0) {
        const newData = data.map((item) => {
          for(let i=0 ; i<statusList.length; i++) {
            if(item.status === statusList[i].id) {
              item.statusName = statusList[i].status;
              return item;
            }
          }
        });
        setHistory(newData);
      } else {
        setHistory(data);
      }
    }
  };

  const color = (id) => {
    if(id === 5 || id === 16){
      return "#68C066";
    } else if (id === 1) {
      return "#1DA1F2";
    } else if (id === 6) {
      return "#FE5F55";
    } else if (id === 10 || id === 11) {
      return "#E85D04B3";
    } else {
      return "#F39237";
    }
  };

  useEffect(() => {
    if (open) {
      getTaskHistoryData(taskId);
    }
  }, [open]);

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      fullWidth
      maxWidth={"sm"}
    >
      <Container>
        <div className="heading">
          <Typography className="text_style">Task History</Typography>
        </div>
        <div className="main">
          {history.length > 0 ?
            history.map((item, index) => {
              return (
                <div 
                  className="task" 
                  key={index}
                  style={{
                    borderLeft: `7px solid ${color(item?.status)}`
                  }}
                >
                  <Typography className="info"><span className="name">{item?.updated_by?.name}</span> changed status to <span className="name">{item?.statusName}</span></Typography>
                  <div className="date_container">
                    <Typography className="date_style">{dayjs(item?.updated_at).format('DD-MMM-YYYY')}</Typography>
                    <Typography className="date_style_1">{new Date(item?.updated_at).toLocaleTimeString()}</Typography>
                  </div>
                </div>
              )
            }) :
            <></>
          }
        </div>

        <div className="bottom_container">
          <CustomButton
            variant="contained"
            className="btn_styl"
            onClick={handleClose}
          >
            Close
          </CustomButton>
        </div>
      </Container>
    </Dialog>
  );

};

export default TaskHistoryDialog;